import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
  position: relative;
  overflow-x: hidden;

  display: block;
  flex-direction: column;
  align-items: center;

  .wave{
    position: absolute;
    z-index: -1;
    top: -45px;
    /* right: 10px; */
  }

  .home-text{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 1.2rem;

  }

  .home-text-title{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    h1{
      font-weight: 700;
      font-size: 3rem;
      color: var(--white);
      text-align: center;
      margin-top: 1.4rem;
      margin-left: 3rem;
      width: 385px;
    }

    .home-text-icon{
      margin-left: 0.4rem;
      margin-top: 1.6rem;

    }
  }

  h4{
    font-weight: 600;
    font-size: 1.5rem;
    color: var(--white);
  }

  .category-farm-dropdown{
      font-size: 28px;
      font-weight: 700;
      color: var(--black);
      text-decoration: none;
    }

  .layout-menu{
    display: flex;
    align-items: center;
    padding-left: 1.6rem;
    position: absolute;
    background: var(--gray-100);
    width: 423px;
    height: 65px;
    right: 13px;
    top: 88px;
    border-radius: 20px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
    transition: filter 0.2s;

    z-index: 2;

    :hover{
      filter: brightness(0.9);
    }

    

    img{
      position: absolute;
      right: 17px;
      bottom: 19px;
    }
  }

  .menu-overlay{
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    cursor: auto;

    z-index: 1;
  }
  
  .return-action{
    width: 100vw;
    height: 89px;
    margin: 0 auto;
    position: absolute;
  
    display: flex;
    align-items: center;

    img{
      cursor: pointer;
      margin-left: 2.4rem;
    }

    h3{
      margin-left: 1.4rem;
      font-size: 1.5rem;
      font-weight: 400;
      color: var(--white);
    }
  }
`
